import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import ConfirmAlert from "../components/ConfirmAlert";

export const smartConfirm = async (params: {
    title?: string;
    message: string;
}) => {
    return await new Promise((res) => {
        return confirmAlert({
            customUI: ({ onClose }) => {
                return ConfirmAlert({
                    ...params,
                    onConfirm: () => {
                        res(true);
                        onClose();
                    },
                    onCancel: () => {
                        res(false);
                        onClose();
                    }
                });
            }
        });
    });
};

export const smartAlert = async (message: string) => {
    return await new Promise((res) => {
        return confirmAlert({
            customUI: ({ onClose }) => {
                return ConfirmAlert({
                    message,
                    onConfirm: () => {
                        res(null);
                        onClose();
                    }
                });
            }
        });
    });
};
